import { DIVIDER, END, HIGHLIGHT_MARK_REG_EXP, NEW_LINE, START } from '../constants/string';

import { getEscapedFolderName } from '@/modules/common/helpers/embedCodeParams';

import logger from './logger';

export const escapeStringRegexp = (str: string): string => {
  if (typeof str !== 'string') {
    logger.error('Unexpected value in the *escapeStringRegexp*', str);
  }

  return (str || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const addHighlightMarks = (value: string): string =>
  value ? `${DIVIDER}${START}${value}${END}${DIVIDER}` : value;

type HighlightSegment = {
  id: string;
  isHighlighted: boolean;
  value: string;
};

const processHighlightsString = (str: string): HighlightSegment[] =>
  str
    .split(DIVIDER)
    .filter((segment) => !!segment.length)
    .map((rawText, index) => {
      let isHighlighted = false;

      const value = rawText.replace(HIGHLIGHT_MARK_REG_EXP, () => {
        isHighlighted = true;
        return '';
      });

      return {
        id: `${value}-${index}`,
        isHighlighted,
        value,
      };
    });

export const getHighlightsInSearchString = (query: string, text: string): HighlightSegment[] => {
  const hlString = text.replace(new RegExp(escapeStringRegexp(query), 'gi'), (match) => addHighlightMarks(match));

  return processHighlightsString(hlString);
};

export const parseTags = (text: string): HighlightSegment[] => {
  const hlString = text
    .replace(/https?:\/\//gm, (match) => ` ${match}`)
    .replace(/(https?:\/\/.*?)(\s|\t|\n|\r|$)/gm, (_, $1, $2) => `${addHighlightMarks($1)}${$2}`)
    .replace(/[\n\r]/gm, () => addHighlightMarks(NEW_LINE));

  return processHighlightsString(hlString);
};

export const getUniqueAppId = (() => {
  const randomSessionKey: string = Math.random().toString(36).split('.').pop() as string;

  let index = 0;
  let prevDate = 0;

  return (): string => {
    const nextDate = Date.now();
    index = prevDate === nextDate ? index + 1 : 0;
    prevDate = nextDate;

    let string = `${getEscapedFolderName('-')}-${randomSessionKey}-${nextDate.toString(36)}`;

    if (index) {
      string += `-${index}`;
    }

    return string;
  };
})();
